function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "className",
    "hasFocus",
    "isValidating",
    "isProcessingProps",
    "error",
    "onValueChange"
];
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { unstable_composeClasses as composeClasses, unstable_useId as useId, unstable_useEnhancedEffect as useEnhancedEffect } from '@mui/utils';
import { getDataGridUtilityClass } from "../../constants/gridClasses.js";
import { useGridRootProps } from "../../hooks/utils/useGridRootProps.js";
import { useGridApiContext } from "../../hooks/utils/useGridApiContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: [
            'editBooleanCell'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
function GridEditBooleanCell(props) {
    var _rootProps_slotProps;
    var idProp = props.id, value = props.value, field = props.field, className = props.className, hasFocus = props.hasFocus, onValueChange = props.onValueChange, other = _objectWithoutPropertiesLoose(props, _excluded);
    var apiRef = useGridApiContext();
    var inputRef = React.useRef(null);
    var id = useId();
    var _React_useState = _sliced_to_array(React.useState(value), 2), valueState = _React_useState[0], setValueState = _React_useState[1];
    var rootProps = useGridRootProps();
    var ownerState = {
        classes: rootProps.classes
    };
    var classes = useUtilityClasses(ownerState);
    var handleChange = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(event) {
            var newValue;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        newValue = event.target.checked;
                        if (!onValueChange) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            onValueChange(event, newValue)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        setValueState(newValue);
                        return [
                            4,
                            apiRef.current.setEditCellValue({
                                id: idProp,
                                field: field,
                                value: newValue
                            }, event)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        apiRef,
        field,
        idProp,
        onValueChange
    ]);
    React.useEffect(function() {
        setValueState(value);
    }, [
        value
    ]);
    useEnhancedEffect(function() {
        if (hasFocus) {
            inputRef.current.focus();
        }
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ _jsx("label", _extends({
        htmlFor: id,
        className: clsx(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ _jsx(rootProps.slots.baseCheckbox, _extends({
            id: id,
            inputRef: inputRef,
            checked: Boolean(valueState),
            onChange: handleChange,
            size: "small"
        }, (_rootProps_slotProps = rootProps.slotProps) === null || _rootProps_slotProps === void 0 ? void 0 : _rootProps_slotProps.baseCheckbox))
    }));
}
process.env.NODE_ENV !== "production" ? GridEditBooleanCell.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * GridApi that let you manipulate the grid.
   */ api: PropTypes.object.isRequired,
    /**
   * The mode of the cell.
   */ cellMode: PropTypes.oneOf([
        'edit',
        'view'
    ]).isRequired,
    changeReason: PropTypes.oneOf([
        'debouncedSetEditCellValue',
        'setEditCellValue'
    ]),
    /**
   * The column of the row that the current cell belongs to.
   */ colDef: PropTypes.object.isRequired,
    /**
   * The column field of the cell that triggered the event.
   */ field: PropTypes.string.isRequired,
    /**
   * The cell value formatted with the column valueFormatter.
   */ formattedValue: PropTypes.any,
    /**
   * If true, the cell is the active element.
   */ hasFocus: PropTypes.bool.isRequired,
    /**
   * The grid row id.
   */ id: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]).isRequired,
    /**
   * If true, the cell is editable.
   */ isEditable: PropTypes.bool,
    isProcessingProps: PropTypes.bool,
    isValidating: PropTypes.bool,
    /**
   * Callback called when the value is changed by the user.
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {boolean} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */ onValueChange: PropTypes.func,
    /**
   * The row model of the row that the current cell belongs to.
   */ row: PropTypes.any.isRequired,
    /**
   * The node of the row that the current cell belongs to.
   */ rowNode: PropTypes.object.isRequired,
    /**
   * the tabIndex value.
   */ tabIndex: PropTypes.oneOf([
        -1,
        0
    ]).isRequired,
    /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */ value: PropTypes.any
} : void 0;
export { GridEditBooleanCell };
export var renderEditBooleanCell = function(params) {
    return /*#__PURE__*/ _jsx(GridEditBooleanCell, _extends({}, params));
};
